import { url } from '../../Server/url/GlobalUrl';

const CVRegistrationApi = (data,registerThis) => {
    console.log('data',data)
    fetch(url + '/api/v1/user/submit-details/' + localStorage.getItem('cv-id') + '/', {
        method: 'PUT',
        body: data
    })
        .then((response) => {
            console.log("response", response)
            if (response['status'] === 201 || response['status'] === 200) {

                  fetch((url + "/api/v1/user/applicant-status/?type=Pre Screen Applicant"), {
                    method: 'GET'
                    })
                  .then(res => res.json())
                  .then(
                    (result) => {
                      console.log('contract_type',result,result[0].id)
                      let form_data_1 = new FormData();
                        form_data_1.append('user', localStorage.getItem('cv-id'));
                        form_data_1.append('status', result[0].id);
                      fetch(url + '/api/v1/user/applicant-role-status/', {
                        method: 'POST',
                        body: form_data_1
                        })
                    .then((response) => {
                        console.log("response", response)
                        if (response['status'] === 201 || response['status'] === 200) {
                            window.location.replace('/registration/cv-summary')
                            return response.json()
                        } else if (response['status'] === 400) {
                            window.location.replace('/registration/cv-summary')
                            return response.json()
                        }
                    })
                    .then((result) => {
                        console.log('result',result)
                    })
                    },
                    (error) => {
                      console.log('error',error)
                    })

                return response.json()
            } else if (response['status'] === 400) {
                registerThis.showCustomModal()
				registerThis.setState({authResponse:'Please check the validations above'})
                return response.json()
            }
        })
        .then((result) => {console.log('result',result)
        })
        .catch(error => {
            console.log(error)
        });
};

export { CVRegistrationApi };


const CVEditApi = (data,registerThis) => {
    console.log('data-edit',data)
    if (localStorage.getItem('actual-id')){
        var id = localStorage.getItem('actual-id')
      }else{
        var id = localStorage.getItem('cv-id')
      }
    fetch(url + '/api/v1/user/submit-details/'+id+'/', {
        method: 'PUT',
        body: data
    })
        .then((response) => {
            console.log("response", response)
            if (response['status'] === 201 || response['status'] === 200) {
//                registerThis.showCustomModal()
//				registerThis.setState({authResponse:'Thanks for Registering,our delicates will reach you soon'})
                fetch((url + "/api/v1/user/applicant-status/?type=Pre Screen Applicant"), {
                    method: 'GET'
                    })
                .then(res => res.json())
                .then(
                    (result) => {
                    console.log('contract_type',result,result[0].id)
                    let form_data_1 = new FormData();
                        form_data_1.append('user', localStorage.getItem('cv-id'));
                        form_data_1.append('status', result[0].id);
                    fetch(url + '/api/v1/user/applicant-role-status/', {
                        method: 'POST',
                        body: form_data_1
                        })
                    .then((response) => {
                        console.log("response", response)
                        if (response['status'] === 201 || response['status'] === 200) {
                            localStorage.removeItem('actual-id')
                            window.location.replace('/registration/cv-summary')
                            return response.json()
                        } else if (response['status'] === 400) {
                            localStorage.removeItem('actual-id')
                            window.location.replace('/registration/cv-summary')
                            return response.json()
                        }
                    })
                    .then((result) => {
                        console.log('result',result)
                    })
                    },
                    (error) => {
                    console.log('error',error)
                    })
                // window.location.replace('/registration/cv-summary')
                return response.json()
            } else if (response['status'] === 400) {
                registerThis.showCustomModal()
				registerThis.setState({authResponse:'Please check the validations above'})
                return response.json()
            }
        })
        .then((result) => {console.log('result',result)
        })
        .catch(error => {
            console.log(error)
        });
};

export { CVEditApi };